import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		width: 20.5,
		height: 20.5,
		x: 1.75,
		y: 1.75,
		stroke: "#262626",
		strokeWidth: 1.5,
		rx: 1.25
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Crect%20width%3D%2220.5%22%20height%3D%2220.5%22%20x%3D%221.75%22%20y%3D%221.75%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20rx%3D%221.25%22%2F%3E%3C%2Fsvg%3E";
